import { render } from "./QuestContainer.vue?vue&type=template&id=32f2c0cb"
import script from "./QuestContainer.vue?vue&type=script&lang=js"
export * from "./QuestContainer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__